import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "role", "onKeyDown"];
import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledDropdownItem } from './sharedStyles';
import useDropdownContext from './useDropdownContext';
const displayName = 'DropdownCustomItem';
const Root = styled.div.withConfig({
  displayName: "DropdownCustomItem__Root",
  componentId: "sc-f3oafp-0"
})(["", ""], StyledDropdownItem);
const DropdownCustomItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      disabled,
      role,
      onKeyDown
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    keyboardNavigationProps
  } = useDropdownContext();
  const handleOnKeyDown = useCallback(event => {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    if (event.key === ' ' || event.key === 'Enter') event.target.click();
  }, [onKeyDown]);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    disabled: disabled,
    "aria-disabled": disabled,
    onKeyDown: handleOnKeyDown,
    role: role,
    tabIndex: "-1",
    ref: ref
  }, keyboardNavigationProps), children);
});
DropdownCustomItem.displayName = displayName;
DropdownCustomItem.Style = Root;
DropdownCustomItem.defaultProps = {
  as: 'div',
  disabled: false,
  selected: false,
  role: 'menuitem'
};
process.env.NODE_ENV !== "production" ? DropdownCustomItem.propTypes = {
  /**
   * Set element type to be rendered for this component. By default it will be render a `<div>` element.
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  /**
   * Sets the children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Disables the `Dropdown.CustomItem`.
   */
  disabled: PropTypes.bool
} : void 0;
export default DropdownCustomItem;